import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IResponse } from '../models/response.interface';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TppCommonService } from '@nspk/tpp-front-commons';

@Injectable({
    providedIn: 'root'
})
export class RequestService {

    /**
     * Префикс всех адресов запросов
     *
     * @private
     */
    private prefix = '/api/v1';

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private tppCommonService: TppCommonService
    ) {
    }

    /**
     * Получение данных с сервера
     *
     * @param url - адрес запроса
     * @param params - данные для отправки в запросе
     */
    get<T>(url: string, params: any = {}): Observable<T> {
        const httpParams = new HttpParams();
        Object.keys(params).forEach(param => {
            httpParams.set(param, params[param]);
        });

        return this.httpClient
            .get<IResponse<T>>(this.prefix + url, { params })
            .pipe(
                map(result => result.result),
                catchError(e => {
                    this.errorHandling(e);
                    return throwError(e);
                })
            );
    }

    /**
     * Отправка данных на сервер
     *
     * @param url - адрес запроса
     * @param data - данные для отправки
     */
    post<T>(url: string, data: any): Observable<T> {
        return this.httpClient
            .post<IResponse<T>>(this.prefix + url, data)
            .pipe(
                map(result => result.result),
                catchError(e => {
                    this.errorHandling(e);
                    return throwError(e);
                })
            );
    }

    /**
     * Обработка ошибок запросов - если необходимо - показывает тост с сообщением об ошибке. Если в ошибке есть backUrl то редиректит
     * на него; если нет то редиректит на страницу с ошибкой внутри приложения
     *
     * @param error - ошибка
     * @private
     */
    private errorHandling(error: any) {
        if (error.error?.result?.backUrl) {
            window.location.href = error.error.result.backUrl;
        } else {
            this.tppCommonService.setCookie('gsRequestError', true);
            this.router.navigate(['/error']);
        }
    }
}
